(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/game/views/package-huxflux-button.js') >= 0) return;  svs.modules.push('/components/numbergames/game/views/package-huxflux-button.js');
(function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.numbergames=_svs.numbergames||{};
_svs.numbergames.game=_svs.numbergames.game||{};
_svs.numbergames.game.templates=_svs.numbergames.game.templates||{};
svs.numbergames.game.templates.package_huxflux_button = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return container.escapeExpression((lookupProperty(helpers,"ui")||(depth0 && lookupProperty(depth0,"ui"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"button",{"name":"ui","hash":{"class":"js-huxflux-btn","transparent":(depth0 != null ? lookupProperty(depth0,"transparentButton") : depth0),"size":400,"title":"Slumpa","inverted":(depth0 != null ? lookupProperty(depth0,"invertedButton") : depth0)},"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":1,"column":135}}}))
    + "\n";
},"useData":true});
Handlebars.partials['components-numbergames-game-package_huxflux_button'] = svs.numbergames.game.templates.package_huxflux_button;
})(svs, Handlebars);


 })(window);